"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));
var _RadioButtonUnchecked = _interopRequireDefault(require("@material-ui/icons/RadioButtonUnchecked"));
var _styles = require("@material-ui/core/styles");
var _hover = require("../../hooks/hover");
var _excluded = ["name", "checked", "onChange", "size", "iconSize", "outerHovered"];
var ThemedCheckbox = (0, _styles.withStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    root: function root(_ref2) {
      var hovered = _ref2.hovered;
      return {
        //todo: confirm the hover and foucs color.
        backgroundColor: hovered ? palette.secondary.main : undefined,
        '&:hover': {
          backgroundColor: palette.secondary.main
        }
      };
    }
  };
})(_Checkbox["default"]);
var Checkbox = function Checkbox(_ref3) {
  var name = _ref3.name,
    checked = _ref3.checked,
    _onChange = _ref3.onChange,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'medium' : _ref3$size,
    _ref3$iconSize = _ref3.iconSize,
    iconSize = _ref3$iconSize === void 0 ? 'default' : _ref3$iconSize,
    _ref3$outerHovered = _ref3.outerHovered,
    outerHovered = _ref3$outerHovered === void 0 ? false : _ref3$outerHovered,
    rest = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  var _useHover = (0, _hover.useHover)(),
    hovered = _useHover.hovered,
    targetProps = _useHover.targetProps;
  var isHovered = outerHovered || hovered;
  return /*#__PURE__*/_react["default"].createElement(ThemedCheckbox, (0, _extends2["default"])({
    size: size,
    color: "primary",
    disableRipple: true,
    checked: checked,
    hovered: outerHovered,
    onChange: function onChange(e) {
      return _onChange(e.target.checked, e.nativeEvent.shiftKey);
    },
    icon: /*#__PURE__*/_react["default"].createElement(_RadioButtonUnchecked["default"], {
      fontSize: iconSize,
      className: (0, _classnames["default"])({
        'text-gray-medium opacity-100': !checked && isHovered,
        'text-gray-light dark:text-gray-medium dark:opacity-25': !checked && !isHovered
      })
    }),
    checkedIcon: /*#__PURE__*/_react["default"].createElement(_CheckCircle["default"], {
      fontSize: iconSize
    })
  }, targetProps, rest));
};
var _default = exports["default"] = Checkbox;
//# sourceMappingURL=index.js.map